// react-hook-formのエラー時のフォーカスが、縦並びのチェックボックスの中央要素に行くようにするために
// 中央要素のときのみrefを返すようにするための関数
export const refForCenterOfCheckboxes = ({
  length,
  index,
  isInvalid,
  ref,
}: {
  length: number;
  index: number;
  isInvalid: boolean;
  ref: React.Ref<never>;
}) => (Math.round(length / 2) === index && isInvalid ? ref : null);
